import { createShortcutsStore } from '@/handler/shortcuts'

// Lista independiente de Favoritos (shortcuts.js): el usuario la cura a mano
// desde Mi Espacio (botón "Agregar" y el "×" de cada tile) para dejar a la
// vista los accesos que más usa. Fijar/quitar Favoritos en el buscador
// global (Ctrl+K) o en el aside no la toca.
const mySpaceShortcuts = createShortcutsStore('my_space_shortcuts_user_', 'my_space_shortcuts')

export default mySpaceShortcuts
